var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5 18.125C44.0888 18.125 18.625 43.5888 18.625 75C18.625 106.411 44.0888 131.875 75.5 131.875C106.911 131.875 132.375 106.411 132.375 75C132.375 43.5888 106.911 18.125 75.5 18.125ZM7.375 75C7.375 37.3756 37.8756 6.875 75.5 6.875C113.124 6.875 143.625 37.3756 143.625 75C143.625 112.624 113.124 143.125 75.5 143.125C37.8756 143.125 7.375 112.624 7.375 75Z",
    fill: "#20A3BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.375 75C7.375 71.8934 9.8934 69.375 13 69.375H138C141.107 69.375 143.625 71.8934 143.625 75C143.625 78.1066 141.107 80.625 138 80.625H13C9.8934 80.625 7.375 78.1066 7.375 75Z",
    fill: "#20A3BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5 6.875C77.0802 6.875 78.5875 7.53965 79.6532 8.70637C96.2058 26.8278 105.613 50.3448 106.124 74.8828C106.125 74.9609 106.125 75.0391 106.124 75.1172C105.613 99.6552 96.2058 123.172 79.6532 141.294C78.5875 142.46 77.0802 143.125 75.5 143.125C73.9198 143.125 72.4125 142.46 71.3468 141.294C54.7942 123.172 45.3874 99.6552 44.8762 75.1172C44.8746 75.0391 44.8746 74.9609 44.8762 74.8828C45.3874 50.3448 54.7942 26.8278 71.3468 8.70637C72.4125 7.53965 73.9198 6.875 75.5 6.875ZM56.1263 75C56.5607 94.6256 63.3964 113.511 75.5 128.821C87.6035 113.511 94.4393 94.6256 94.8737 75C94.4393 55.3744 87.6035 36.4894 75.5 21.179C63.3964 36.4894 56.5607 55.3744 56.1263 75Z",
    fill: "#20A3BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.2bdab4a8ec277550b128517b0c56d658.svg";
export { ForwardRef as ReactComponent };